import React, { FC, useMemo } from "react";
import { View } from "react-native";
import { useI18nMessage } from "@lookiero/i18n-react";
import { Text } from "@lookiero/sty-psp-ui";
import { ButtonIcon } from "@lookiero/sty-psp-ui";
import { useStaticInfo } from "../../../../hooks/useStaticInfo";
import { DOMAIN, I18nMessages, PREFIX } from "../../../../i18n/i18n";
import { Header } from "../Header";
import { style as homeHeaderStyle } from "./HomeHeader.style";

interface HomeHeaderProps {
  readonly onBack?: () => void;
}
const HomeHeader: FC<HomeHeaderProps> = ({ onBack }) => {
  const {
    customer: { segment },
  } = useStaticInfo();

  const titleText = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.HEADER_TITLE,
    prefix: PREFIX,
    values: { segment: segment.toLowerCase() },
  });

  const style = useMemo(() => homeHeaderStyle(), []);

  return (
    <Header testID="home-header">
      <ButtonIcon name="arrow_left" testID="back-button-icon" onPress={onBack} />
      <Text level={3} variant="action">
        {titleText}
      </Text>
      <View style={style.buttonIconPlaceholder} />
    </Header>
  );
};
export { HomeHeader };
